module.exports = __webpack_public_path__ + "aw.no1.2399063f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aw.no1.jpg
// module id = Zb52
// module chunks = 0